import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import redbell from '../../images/redbell.svg';
import { getLocations } from '../../sagas/locationsSaga/reducer';
import { init as getPackages } from '../../sagas/packagesSaga/reducer';
import { getTimedEvents } from '../../sagas/timedEventsSaga/reducer';

import MaterialIcon from 'material-icons-react';
import '../AuthTopBar/Toolbar.css';

class HomeNotices extends Component {
  constructor() {
    super();
    this.openLocationChooser = this.openLocationChooser.bind(this);
    this.closeLocationChooser = this.closeLocationChooser.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.confirmLocationChange =
      this.confirmLocationChange.bind(this);
    this.state = {
      loading: false,
      location: 'St. Louis',
      zoneId: 11,
      showLocationChooser: false,
      pendingLocation: 'St. Louis',
      pendingZoneId: 11,
    };
  }

  componentDidMount() {
    const storedZoneId = localStorage.getItem('selectedZoneId');
    const zoneId = storedZoneId
      ? parseInt(storedZoneId, 10)
      : this.props.profile.zoneId || 11;
    const location = zoneId === 10 ? 'Kansas City' : 'St. Louis';
    this.setState({
      location,
      zoneId,
      pendingLocation: location,
      pendingZoneId: zoneId,
    });
  }

  openLocationChooser() {
    this.setState({
      showLocationChooser: true,
      pendingLocation: this.state.location,
      pendingZoneId: this.state.zoneId,
    });
  }

  closeLocationChooser() {
    this.setState({ showLocationChooser: false });
  }

  selectLocation(location) {
    const zoneId = location === 'Kansas City' ? 10 : 11;
    this.setState({
      pendingLocation: location,
      pendingZoneId: zoneId,
    });
  }

  confirmLocationChange() {
    const location =
      this.state.pendingLocation || this.state.location;
    const zoneId = this.state.pendingZoneId || this.state.zoneId;
    this.setState(
      {
        location,
        zoneId,
        showLocationChooser: false,
      },
      () => {
        localStorage.setItem('selectedZoneId', zoneId);
        this.props.getLocations(zoneId);
        this.props.getPackages(zoneId);
        this.props.getTimedEvents(zoneId);
      },
    );
  }

  locationChangeDisplay() {
    return (
      <div className="toolbar__location">
        <div className="location-current">
          <span className="location-current-text">
            <MaterialIcon icon="place" size={16} />{' '}
            {this.state.location}
          </span>
          <button
            type="button"
            className="location-change-link"
            onClick={this.openLocationChooser}
          >
            Change
          </button>
        </div>
        {this.state.showLocationChooser && (
          <div className="location-modal-backdrop">
            <div className="location-modal">
              <button
                type="button"
                className="location-modal-close"
                onClick={this.closeLocationChooser}
                aria-label="Close"
              >
                ×
              </button>
              <div className="location-modal-header">
                Choose Location
              </div>
              <div className="location-modal-list">
                <button
                  type="button"
                  className={
                    this.state.pendingLocation === 'St. Louis'
                      ? 'location-option selected'
                      : 'location-option'
                  }
                  onClick={() => this.selectLocation('St. Louis')}
                >
                  <span>St. Louis</span>
                  <span className="location-option-icon">
                    <MaterialIcon icon="place" size={18} />
                  </span>
                </button>
                <button
                  type="button"
                  className={
                    this.state.pendingLocation === 'Kansas City'
                      ? 'location-option selected'
                      : 'location-option'
                  }
                  onClick={() => this.selectLocation('Kansas City')}
                >
                  <span>Kansas City</span>
                  <span className="location-option-icon">
                    <MaterialIcon icon="place" size={18} />
                  </span>
                </button>
              </div>
              <div className="location-modal-actions">
                <button
                  type="button"
                  className="location-modal-cancel"
                  onClick={this.closeLocationChooser}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="location-modal-confirm"
                  onClick={this.confirmLocationChange}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  getContent(mode, sortedActivites) {
    if (sortedActivites.length === 0) {
      return (
        <div>
          <Row className=" no-margin no-padding">
            <div className="fullwidth center">
              <div
                style={{
                  marginBottom: '6px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                {this.locationChangeDisplay()}
              </div>
              <h2 style={{ marginTop: '0px' }}>Welcome to Trevel!</h2>
              <center>
                <p>To get started, just ring the bell icon below. </p>

                <img
                  src={redbell}
                  style={{ width: '40px' }}
                  alt="logo"
                />
              </center>
            </div>
          </Row>
        </div>
      );
    } else {
      return (
        <div>
          <Row className=" no-margin no-padding">
            <div className="fullwidth">
              <div
                style={{ textAlign: 'center', paddingTop: '10px' }}
              >
                <span className="title">Today's Notices</span>
              </div>
              <ul className="no-padding no-margin">
                {sortedActivites.map((edit, index) => (
                  <div>
                    {this.listActivity(
                      edit,
                      index,
                      sortedActivites.length,
                    )}
                  </div>
                ))}
              </ul>
            </div>
          </Row>
        </div>
      );
    }
  }

  listActivity(edit, index, count) {
    return (
      <li
        className="adminlistitem"
        style={{
          borderBottom: count - 1 !== index ? '1px solid grey' : '',
        }}
      >
        <Link
          to={{
            pathname: '/event/' + edit.eventId,
            state: {
              backpath: '/home',
            },
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                width: '45px',
              }}
            >
              <MaterialIcon
                icon={edit.icon}
                size={30}
                color={edit.iconColor}
              />
            </div>
            <div
              style={{
                display: 'block',
                float: 'left',
                width: '90%',
              }}
            >
              <span
                style={{
                  color: 'black',
                  fontWeight: '600',
                }}
              >
                {edit.eventTitle}
              </span>
              <span
                style={{
                  color: 'black',
                  display: 'block',
                  clear: 'both',
                }}
              >
                {edit.message}
              </span>
              <span
                style={{
                  display: 'block',
                  clear: 'both',
                  color: 'grey',
                  fontSize: '12px',
                }}
              >
                {edit.date}
              </span>
            </div>
            <div
              style={{
                display: 'block',
                float: 'right',
              }}
            >
              <MaterialIcon
                icon="arrow_right"
                size={30}
                color="rgb(242, 29, 89)"
              />
            </div>
          </div>
        </Link>
      </li>
    );
  }

  sortByDate(array, dateField, order = 'desc') {
    return array.sort((a, b) => {
      const dateA = moment(a[dateField]);
      const dateB = moment(b[dateField]);

      if (order === 'asc') {
        return dateA.valueOf() - dateB.valueOf();
      } else if (order === 'desc') {
        return dateB.valueOf() - dateA.valueOf();
      }
    });
  }

  getDate(timestamp) {
    let myDate = new Date(timestamp * 1000);
    let dayTextFinal = moment(myDate).format('MM/DD/YYYY, h:mm:ss a');
    return dayTextFinal;
  }

  sortActivites(events) {
    let notificationsArray = [];
    let eventNotices = [];

    if (events !== undefined) {
      events.forEach((event) => {
        let notice = {
          message: '',
          date: '',
          timestamp: '',
          eventId: '',
          eventTitle: '',
          icon: '',
        };
        let message = '';

        let reverseArray = [...event.editHistory].reverse();

        if (event.status === 0) {
          if (reverseArray[0].eventType === 2) {
            if (
              this.props.profile.userId !== reverseArray[0].userId
            ) {
              let name = event.users[
                reverseArray[0].userId
              ].profile.fullName.replace(/ .*/, '');
              message = name + ' Approved your event together!';

              notice.message = message;
              notice.date = this.getDate(
                reverseArray[0].editDate.seconds,
              );
              notice.eventId = event.eventId;
              notice.timestamp = reverseArray[0].editDate.seconds;
              notice.eventTitle = event.title;
              // notice.icon = 'thumb_up_alt_outlined_icon';
              notice.icon = 'done_outline_outlined';
              notice.iconColor = 'green';
              notificationsArray.push(notice);
            }
          }
        } else if (event.status === 2) {
          if (reverseArray[0].eventType === 1) {
            if (
              this.props.profile.userId !== reverseArray[0].userId
            ) {
              let name = event.users[
                reverseArray[0].userId
              ].profile.fullName.replace(/ .*/, '');
              message = name + " edited your event. It's your turn.";

              notice.message = message;
              notice.date = this.getDate(
                reverseArray[0].editDate.seconds,
              );
              notice.eventId = event.eventId;
              notice.eventTitle = event.title;
              notice.icon = 'notification_important_outlined';
              notice.iconColor = 'rgb(242, 29, 89)';
              notificationsArray.push(notice);
            }
          }
        } else if (reverseArray[0].eventType === 3) {
          if (this.props.profile.userId !== reverseArray[0].userId) {
            let name = event.users[
              reverseArray[0].userId
            ].profile.fullName.replace(/ .*/, '');

            if (
              event.creationDetails.plannerId ===
              this.props.profile.userId
            ) {
              message = name + ' Rejected your invitation.';
            } else {
              message = name + ' Rejected your changes to the event.';
            }

            notice.message = message;
            notice.date = this.getDate(
              reverseArray[0].editDate.seconds,
            );
            notice.eventId = event.eventId;
            notice.eventTitle = event.title;
            notice.icon = 'do_disturb';
            notice.iconColor = 'grey';
            notificationsArray.push(notice);
          }
        }
      });
    }

    let sortedNotices = this.sortByDate(notificationsArray, 'date');

    sortedNotices.forEach((notice) => {
      if (eventNotices.length !== 5) {
        eventNotices.push(notice);
      }
    });

    return eventNotices;
  }

  render() {
    let sortedActivites = this.sortActivites(this.props.events);
    return (
      <div style={{ padding: '10px' }}>
        {this.getContent(this.state.mode, sortedActivites)}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    events: state.events.events,
    profile: state.profile.profile,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getLocations: (zoneId) => {
      dispatch(getLocations(zoneId));
    },
    getPackages: (zoneId) => {
      dispatch(getPackages(zoneId));
    },
    getTimedEvents: (zoneId) => {
      dispatch(getTimedEvents(zoneId));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HomeNotices);
